import { Breakpoint, Color, FontWeight, Markdown, SideNote, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { PartProps, WrapperProps } from './dualContentSlide.types';

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: ${({ $withImage, $reversed }: WrapperProps): string => $withImage || $reversed ? 'column' : 'column-reverse'};
  align-items: center;
  padding: 0 16px 64px;
  gap: 24px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: ${({ $withImage, $reversed }: WrapperProps): string => $withImage || $reversed ? 'row' : 'row-reverse'};
    padding: ${({ $withImage }: WrapperProps): string => $withImage ? '40px 0 80px 80px' : '40px 80px 80px'};
    ${({ $withImage }: WrapperProps): string | false => !$withImage && 'gap: 80px'};
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 24px;
`;

export const PartsWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const Part = styled.div<PartProps>`
  width: 40px;
  height: 2px;
  background-color: ${({ $isActive }: PartProps): Color => $isActive ? Color.MediumTurquoise : Color.Gray400};
`;

export const StyledMarkdown = styled(Markdown)`
  display: flex;
  flex-direction: column;

  em {
    font-weight: ${FontWeight.Bold};
    color: ${Color.Brand100};
    font-style: normal;
  }
`;

export const Image = styled.img`
  width: 100%;
  max-width: 500px;

  @media ${Breakpoint.SmallDesktop} {
    height: 350px;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media ${Breakpoint.SmallDesktop} {
    gap: 24px;
  }
`;

export const ListItem = styled.li``;

export const List = styled.ul`
  list-style-type: disc;
  padding-left: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${ListItem}::marker {
    color: ${Color.Brand100};
    font-size: 16px;
  }
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
    align-items: stretch;
  }
`;

export const Detail = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  background-color: ${Color.LightTurquoise};

  @media ${Breakpoint.SmallDesktop} {
    width: fit-content;
    justify-content: flex-start;
    text-align: start;
  }
`;

export const DetailOperator = styled(Typography)`
  display: flex;
  align-items: center;
`;

export const StripsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
`;

export const Strip = styled.div`
  width: 100%;
  padding: 10px 20px;
  background-color: ${Color.LightTurquoise};
`;

export const StripText = styled(Markdown)`
  display: flex;
  flex-direction: column;
  color: ${Color.Gray800};

  em {
    font-weight: ${FontWeight.Bold};
    color: ${Color.Brand100};
    font-style: normal;
  }
`;

export const StyledSideNote = styled(SideNote)`
  width: 100%;
  flex: 1;
`;
